import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

const ProjectNotesSkeleton: React.FC = () => (
  <TableContainer component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell {...tableHeaderStyles}>Created</TableCell>
          <TableCell {...tableHeaderStyles}>Note</TableCell>
          <TableCell {...tableHeaderStyles}>Created By</TableCell>
          <TableCell {...tableHeaderStyles}>Last Updated</TableCell>
          <TableCell {...tableHeaderStyles}>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(3)].map((_, index) => (
          <TableRow key={index}>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={90} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Box>
                <Skeleton variant="text" width="100%" height={16} />
                <Skeleton variant="text" width="85%" height={14} />
                <Skeleton variant="text" width="70%" height={14} />
              </Box>
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={120} height={16} />
              </Box>
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={90} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="circular" width={24} height={24} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ProjectNotesSkeleton; 